module.exports = __webpack_public_path__ + "static/share-upside-4265ec1fd2fc47864a029cd24d33cb17.png";